import React, { useState } from "react";
import { Button } from "@mui/material";
import RunSweepInput from "./RunSweepInput.jsx";
import { empty_uuid } from "./Account_urls.jsx";

const RunSweep = ({ clientJson, c_callback }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onSubmit = () => {
    handleShow();
  };

  return (
    <>
      <Button
        variant="contained"
        disabled={clientJson.readonly ||
          clientJson.Scenario.uuid === empty_uuid}
        onClick={onSubmit}
      >
        Run Sweep
      </Button>
      <RunSweepInput
        show={show}
        onClose={handleClose}
        clientJson={clientJson}
        c_callback={c_callback}
      />
    </>
  );
};

export default RunSweep;
